const CouponActionTypes = {
  START_FETCH_COUPONS: 'START_FETCH_COUPONS',
  FETCH_COUPONS_SUCCESS: 'FETCH_COUPONS_SUCCESS',
  FETCH_COUPONS_FAILURE: 'FETCH_COUPONS_FAILURE',

  START_CREATE_COUPON: 'START_CREATE_COUPON',
  CREATE_COUPON_SUCCESS: 'CREATE_COUPON_SUCCESS',
  CREATE_COUPON_FAILURE: 'CREATE_COUPON_FAILURE',

  FETCH_SINGLE_COUPON: 'FETCH_SINGLE_COUPON',
  FETCH_SINGLE_COUPON_SUCCESS: 'FETCH_SINGLE_COUPON_SUCCESS',
  FETCH_SINGLE_COUPON_FAILURE: 'FETCH_SINGLE_COUPON_FAILURE',

  EXPORT_COUPON_START: 'EXPORT_COUPON_START',
  EXPORT_COUPON_SUCCESS: 'EXPORT_COUPON_SUCCESS',
  EXPORT_COUPON_FAILURE: 'EXPORT_COUPON_FAILURE',

  SET_ANY_DATA: 'SET_ANY_DATA',
};

export default CouponActionTypes;
